import styled from 'styled-components'
import { PairWith } from '@velasca/ui/pair-with'
import { RelatedSoles } from '@velasca/ui/related-soles'
import { ReviewBadge } from '@velasca/ui/review-badge'

export const InfoBlock = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.colors.background};

  @media screen and (min-width: 992px) {
    padding: 0 2rem 1rem 2rem;
    display: flex;
    flex-direction: column;
  }
`

export const Head = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 992px) {
    flex-direction: column-reverse;
  }
`

export const Variants = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
  align-items: center;
`

export const Details = styled.p`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0 0 1rem 0;
`

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`

export const PriceCol = styled(Col)`
  align-items: flex-end;
`

export const StyledReviewBadge = styled(ReviewBadge)`
  padding: 0.5rem 0;
  margin: 0.3rem 0 1rem 0;
`

export const Footer = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
`

export const InfoLinks = styled.div<{ length: number }>`
  display: flex;
  cursor: pointer;
  margin: 1.6rem 0;
  ${({ length }) =>
    length <= 2 ? 'gap: 1rem;' : 'justify-content: space-between;'}
`

export const Separator = styled.div`
  width: 1px;
  margin: 0.2rem;
  background: ${({ theme }) => theme.colors.primary};
  transform: rotate(31deg);
`

export const Hr = styled.hr`
  width: 100%;
  height: 0;
  border-top-color: ${({ theme }) => theme.colors.border};
  margin: 0;
`

export const StyledRelatedSoles = styled(RelatedSoles)`
  flex-wrap: wrap;
  margin: 0 0 2rem;
`

export const StyledPairWith = styled(PairWith)`
  margin: 1rem 0;
`
